module.exports = __webpack_public_path__ + "static/media/gb4.6ec528c4.png";